import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "./organizations.css";

const orgs = [
  "Edmond OWASP",
  "Computer Science Club UCO",
  "Cyber Security Club UCO",
  "Information Warfare Summit",
  "Information System Security Association (ISSA OKC)",
  "DEFCON 405",
  "Hacklahoma",
];

function Organizations() {
  const ref = useScrollReveal();

  return (
    <section ref={ref} id="organizations" className="organizations reveal">
      <div className="section-inner">
        <div className="section-header reveal-child" style={{ '--i': 0 }}>
          <span className="section-number font-mono">05</span>
          <h2 className="section-title">Organizations</h2>
        </div>

        <div className="org-grid reveal-child" style={{ '--i': 1 }}>
          {orgs.map((org, i) => (
            <div className="org-item" key={i}>
              <span className="org-index font-mono">0{i + 1}</span>
              <span className="org-name">{org}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Organizations;
